/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { Helmet } from "react-helmet";

// react-router-dom components
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

// @mui material components
// import Switch from "@mui/material/Switch";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import curved9 from "assets/images/curved-images/curved9.jpg";

import {
  useAuthController,
  setIsAuthenticated,
  setAccessToken,
  setRefreshToken,
} from "context/auth";

import { Auth } from "api";

function Cover() {
  const { t } = useTranslation();
  const [loginEmail, setLoginEmail] = useState("");
  const [password, setPw] = useState("");
  // const [rememberMe, setRememberMe] = useState(true);
  const [, AuthDispatch] = useAuthController();
  const history = useHistory();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const login = async () => {
    setIsLoggingIn(true);
    try {
      const {
        data: { accessToken, refreshToken },
      } = await Auth.login(loginEmail, password);

      if (accessToken) {
        setAccessToken(AuthDispatch, accessToken);
        setRefreshToken(AuthDispatch, refreshToken);
        setIsAuthenticated(AuthDispatch, true);
        history.push("/dashboard");
      }
    } catch (err) {
      console.error(err);
      console.error(err.message);
    }
    setIsLoggingIn(false);
  };

  return (
    <>
      <Helmet>
        <title>{t("Sign In")}</title>
      </Helmet>
      <CoverLayout
        title={t("Sign In")}
        description={t("Enter your email and password to sign in")}
        image={curved9}
      >
        <SuiBox component="form" role="form">
          <SuiBox mb={2} lineHeight={1.25}>
            <SuiBox mb={1} ml={0.5}>
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                {t("Login email")}
              </SuiTypography>
            </SuiBox>
            <SuiInput
              placeholder={t("Login email")}
              onChange={(e) => {
                setLoginEmail(e.target.value);
              }}
              value={loginEmail}
            />
          </SuiBox>
          <SuiBox mb={2} lineHeight={1.25}>
            <SuiBox mb={1} ml={0.5}>
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                {t("Password")}
              </SuiTypography>
            </SuiBox>
            <SuiInput
              type="password"
              placeholder={t("Password")}
              onChange={(e) => {
                setPw(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  login();
                }
              }}
              value={password}
            />
          </SuiBox>

          <SuiBox mt={4} mb={1}>
            <SuiButton
              variant="gradient"
              color="info"
              fullWidth
              disabled={isLoggingIn}
              onClick={login}
              type="submit"
            >
              {t("Sign In")}
            </SuiButton>
          </SuiBox>
          {/* <SuiBox mt={3} textAlign="center">
          <SuiTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t have an account?{" "}
            <SuiTypography
              // component={Link}
              // to="/authentication/sign-up/cover"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Sign up
            </SuiTypography>
          </SuiTypography>
        </SuiBox> */}
        </SuiBox>
      </CoverLayout>
    </>
  );
}

export default Cover;
